<template>
  <div class="navbar">
    <hamburger
      id="hamburger-container"
      :is-active="sidebar.opened"
      class="hamburger-container"
      @toggleClick="toggleSideBar"
    />

    <breadcrumb
      id="breadcrumb-container"
      class="breadcrumb-container"
    />

    <div class="right-menu">
      <template v-if="device !== 'mobile'">
        <div style="display:none">
          <search
            id="header-search"
            class="right-menu-item"
          />
          <error-log class="errLog-container right-menu-item hover-effect" />

          <screenfull
            id="screenfull"
            class="right-menu-item hover-effect"
          />

          <el-tooltip
            content="Global Size"
            effect="dark"
            placement="bottom"
          >
            <size-select
              id="size-select"
              class="right-menu-item hover-effect"
            />
          </el-tooltip>
        </div>
      </template>
      <div class=" task avatar-container right-menu-item">
        <el-dropdown
          class=" hover-effect"
          trigger="click"
        >
          <div class="avatar-wrapper">
            <el-badge
              :value="messagecount>0?messagecount:null"
              style=" margin-top: 4px;"
            >
              <i
                class="el-icon-message-solid"
                style="font-size:26px;"
              ></i>
            </el-badge>
            <!-- <i class="el-icon-caret-bottom" /> -->
          </div>
          <el-dropdown-menu slot="dropdown">
            <!-- <router-link to="/task-center/test-center">
              <el-dropdown-item>检测委托</el-dropdown-item>
            </router-link> -->
            <!--
          <router-link to="/">
            <el-dropdown-item>Dashboard</el-dropdown-item>
          </router-link>
          -->
            <template v-if="approvalList.length>0 ">
              <el-dropdown-item
                divided
                v-for="(item,index) in approvalList"
                :key="index"
              >
                <router-link :to="item.url">
                  <el-dropdown-item>{{item.typeName}}<i
                      style="font-style: normal;margin-left: 5px;color: red;"
                      v-if="item.total>0"
                    >({{item.total}})</i></el-dropdown-item>
                </router-link>
              </el-dropdown-item>
            </template>
            <el-dropdown-item v-else>
              暂无消息
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <el-dropdown
        class="avatar-container right-menu-item hover-effect"
        trigger="click"
      >
        <div class="avatar-wrapper">
          <el-tooltip
            class="item"
            effect="dark"
            :content="name"
            placement="top"
          >
            <img
              :src="'./static/icon.png'"
              class="user-avatar"
            >
          </el-tooltip>
          <i class="el-icon-caret-bottom" />
          <!-- <img :src="avatar+'?imageView2/1/w/80/h/80'" class="user-avatar"> -->

        </div>
        <el-dropdown-menu slot="dropdown">
          <router-link to="/userManagement/chgPwd">
            <el-dropdown-item>修改密码</el-dropdown-item>
          </router-link>
          <!--
          <router-link to="/">
            <el-dropdown-item>Dashboard</el-dropdown-item>
          </router-link>
          -->
          <el-dropdown-item divided>
            <span
              style="display:block;"
              @click="logout"
            >退出</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Breadcrumb from "@/components/Breadcrumb";
import Hamburger from "@/components/Hamburger";
import ErrorLog from "@/components/ErrorLog";
import Screenfull from "@/components/Screenfull";
import SizeSelect from "@/components/SizeSelect";
import Search from "@/components/HeaderSearch";
import { getCountAllType } from "@/api/process/process";

export default {
  components: {
    Breadcrumb,
    Hamburger,
    ErrorLog,
    Screenfull,
    SizeSelect,
    Search
  },
  computed: {
    ...mapGetters(["sidebar", "avatar", "device", "name"])
  },
  data() {
    return {
      approvalList: [],
      messagecount: "" //消息的总数量
    };
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch("app/toggleSideBar");
    },
    async logout() {
      await this.$store.dispatch("user/logout");
      this.$store.dispatch("tagsView/delAllViews"); // 关闭所有tab
      this.$router.push(`/login?redirect=#${this.$route.fullPath}`);
    },
    getApprovalMessage() {
      getCountAllType()
        .then(res => {
          if (res.code == "0") {
            this.approvalList = res.data.approverCountDtoList;
            this.messagecount = res.data.total;
          }
        })
        .catch(err => {
          console.log(123, err);
        });
    },
    timer() {
      return setTimeout(() => {
        this.getApprovalMessage();
      }, 60000);
    }
  },
  created() {
    this.getApprovalMessage();
  },
  watch: {
    approvalList() {
      this.timer();
    }
  },
  destroyed() {
    clearTimeout(this.timer);
  }
};
</script>

<style lang="scss" scoped>
.navbar {
  height: 55px;
  overflow: hidden;
  position: relative;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);

  .hamburger-container {
    line-height: 46px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background 0.3s;
    -webkit-tap-highlight-color: transparent;

    &:hover {
      background: rgba(0, 0, 0, 0.025);
    }
  }

  .breadcrumb-container {
    float: left;
  }

  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }

  .right-menu {
    float: right;
    height: 100%;
    line-height: 50px;
    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background 0.3s;
        &:hover {
          background: rgba(0, 0, 0, 0.025);
        }
      }
    }

    .avatar-container {
      margin-right: 30px;

      .avatar-wrapper {
        margin-top: 5px;
        position: relative;

        .user-avatar {
          cursor: pointer;
          width: 40px;
          height: 40px;
          border-radius: 10px;
        }

        .el-icon-caret-bottom {
          cursor: pointer;
          position: absolute;
          right: -20px;
          top: 25px;
          font-size: 12px;
        }
      }
    }
    .task {
      cursor: pointer;
      transition: background 0.3s;
      &:hover {
        background: rgba(0, 0, 0, 0.025);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/layout/components/Navbar.vue